import React from 'react'
import TextField from '../TextField'
import StartLabelField from './StartLabelField'
import type { TextFieldProps } from '../TextField'

type Props = TextFieldProps & {
    label: string
}

/**
 *  Must be in the grid container to display properly
 * */
export const StartLabelTextField: React.VFC<Props> = ({ name, label, ...fieldProps }: Props) => {
    return (
        <StartLabelField name={name} label={label}>
            <TextField name={name} {...fieldProps} />
        </StartLabelField>
    )
}

export default StartLabelTextField
export type { Props as StartLabelTextFieldProps }
